export interface IDebtPayload {
  sessionId: string;
  parkingLotId: string;
  plateNumber: string;
  amount: number;
  registeredById: string;
  status: string;
}

export interface IDebtItem {
  id: string;
  sessionId: string;
  parkingLotId: string;
  plateNumber: string;
  amount: number;
  registeredById: string;
  resolvedById: string;
  resolvedAt: string;
  status: DebtStatusEnum;
  createdAt: string;
  updatedAt: string;
}

export interface IDebtParams {
  id?: string;
  sessionId?: string;
  plateNumber?: string;
  parkingLotId?: string;
  status?: DebtStatusEnum;
  registeredById?: string;
  resolvedById?: string;
  includes?: DebtIncludesEnum;
  sortOrder?: string;
  orderBy?: string;
  offset?: number;
  count?: number;
}

export enum DebtIncludesEnum {
  None = 'None',
  Session = 'Session',
  ParkingLot = 'ParkingLot',
  RegisteredBy = 'RegisteredBy',
  ResolvedBy = 'ResolvedBy',
}

export enum DebtStatusEnum {
  Open = 'OPEN',
  Resolved = 'RESOLVED',
  Written_off = 'WRITTEN_OFF',
}

export const IDebtStatusLabel: Record<DebtStatusEnum, string> = {
  [DebtStatusEnum.Open]: 'Открыт',
  [DebtStatusEnum.Resolved]: 'Погашен',
  [DebtStatusEnum.Written_off]: 'Списано',
};
